export default __webpack_public_path__ + "e0cc884d5368df0cba7f57544c398497.png";